import { Group, Button, Text } from '@mantine/core';
import { IconLogout } from '@tabler/icons-react';
import { useAuth } from '@/hooks/useAuth';

export function Header() {
  const { user, logout } = useAuth();

  return (
    <Group>
      {user && <Text size="sm">{user.email}</Text>}
      <Button variant="subtle" size="compact-sm" leftSection={<IconLogout size={16} />} onClick={logout}>
        Abmelden
      </Button>
    </Group>
  );
}
